import { render } from "./PrintTemplates.vue?vue&type=template&id=53532c16&scoped=true"
import script from "./PrintTemplates.vue?vue&type=script&lang=js"
export * from "./PrintTemplates.vue?vue&type=script&lang=js"

import "./PrintTemplates.vue?vue&type=style&index=0&id=53532c16&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53532c16"]])

export default __exports__